import React from "react";
import { createContext, useContext, useContextSelector } from "./use-context-selector.js";
const SomeEditorPropsContext = createContext({});
const SomeEditorPropsContextProvider = ({
  children,
  visitorUploads,
  fileUploadSizeLimit,
  biSettings,
  pickMedia,
  generalLinkSettings,
  historySettings,
  helpers,
  iframeSandboxDomain,
  instance
}) => {
  return /* @__PURE__ */ React.createElement(
    SomeEditorPropsContext.Provider,
    {
      value: React.useMemo(
        () => ({
          visitorUploads,
          fileUploadSizeLimit,
          biSettings,
          pickMedia,
          generalLinkSettings,
          helpers,
          historySettings,
          iframeSandboxDomain,
          instance
        }),
        [
          visitorUploads,
          fileUploadSizeLimit,
          biSettings,
          pickMedia,
          generalLinkSettings,
          historySettings,
          helpers,
          iframeSandboxDomain,
          instance
        ]
      )
    },
    children
  );
};
const useEditorProps = () => {
  const context = useContext(SomeEditorPropsContext);
  if (!context) {
    throw new Error("useEditorProps must be used within a SomeEditorPropsContextProvider");
  }
  return context;
};
const useEditorProp = (selector) => {
  const value = useContextSelector(SomeEditorPropsContext, selector, Object.is);
  return value;
};
export {
  SomeEditorPropsContext,
  SomeEditorPropsContextProvider,
  useEditorProp,
  useEditorProps
};
//# sourceMappingURL=some-editor-props-context.js.map
